import { css, cx } from '@bts-web/utils-style-engine';
import { iconWrapper } from './iconWrapper';

export const SmallMoonIcon = ({
  colorToken,
  ariaLabel,
  onClick,
}: {
  colorToken: string;
  ariaLabel: string;
  onClick?: () => void;
}) => (
  <span
    className={cx(iconWrapper(!!onClick), css({ color: colorToken }))}
    data-element="icon"
    aria-label={ariaLabel}
    onClick={onClick}
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="white" />
      <path
        d="M9.45629 4C12.77 4 15.4563 6.68629 15.4563 10C15.4563 13.3137 12.77 16 9.45629 16C7.07502 16 5.01873 14.6128 4.04969 12.6046C3.98182 12.4639 3.98356 12.2997 4.05438 12.1605C4.1252 12.0213 4.25698 11.9232 4.41062 11.8953C5.68609 11.6636 7.68804 10.9579 8.48805 8.82444C9.05064 7.32413 9.00024 5.81021 8.77147 4.59591C8.74447 4.45263 8.78136 4.30471 8.87247 4.19089C8.96358 4.07706 9.09984 4.00867 9.24555 4.00364C9.31552 4.00122 9.38577 4 9.45629 4Z"
        fill="currentColor"
      />
    </svg>
  </span>
);
